import agent from './agent.png'

export const icons = {
  agent
}

export { agent }

export default icons
